export const messages = {
  en: {
    marketWay: {
      title: 'Marketing Management',
      tabText: 'Marketing Text',
      tabPic: 'Marketing Image',
      tabGoods: 'Marketing Goods'
    },
    marketText: {
      title: 'Marketing Text Management',
      name: 'Name',
      sendRate: 'Send Rate',
      content: 'Content',
      config: 'Marketing Config',
      createTime: 'Create Time',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      add: 'Add',
      search: 'Search',
      sendRateOptions: {
        daily: 'Daily',
        monthly: 'Monthly',
        unlimited: 'Unlimited'
      }
    },
    marketPic: {
      title: 'Marketing Image Management',
      image: 'Image',
      name: 'Name',
      url: 'URL',
      createTime: 'Create Time',
      remark: 'Remark',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      add: 'Add',
      search: 'Search'
    },
    marketGoods: {
      title: 'Marketing Goods Management',
      name: 'Name',
      goodsCount: 'Goods Count',
      createTime: 'Create Time',
      remark: 'Remark',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      add: 'Add',
      search: 'Search',
      viewGoods: 'View Goods'
    }
  },
  zh: {
    marketWay: {
      title: '营销管理',
      tabText: '营销文本',
      tabPic: '营销图片',
      tabGoods: '营销商品'
    },
    marketText: {
      title: '营销文本管理',
      name: '名称',
      sendRate: '发送频率',
      content: '内容',
      config: '营销配置',
      createTime: '创建时间',
      operation: '操作',
      edit: '修改',
      delete: '删除',
      add: '添加',
      search: '查询',
      sendRateOptions: {
        daily: '按天',
        monthly: '按月',
        unlimited: '不限制'
      }
    },
    marketPic: {
      title: '营销图片管理',
      image: '图片',
      name: '名称',
      url: '访问地址',
      createTime: '创建时间',
      remark: '备注',
      operation: '操作',
      edit: '修改',
      delete: '删除',
      add: '添加',
      search: '查询'
    },
    marketGoods: {
      title: '营销商品管理',
      name: '名称',
      goodsCount: '商品数',
      createTime: '创建时间',
      remark: '备注',
      operation: '操作',
      edit: '修改',
      delete: '删除',
      add: '添加',
      search: '查询',
viewGoods: '查看商品'
    }
  },
  'zh-TW': {
    marketWay: {
      title: '營銷管理',
      tabText: '營銷文本',
      tabPic: '營銷圖片',
      tabGoods: '營銷商品'
    },
    marketText: {
      title: '營銷文本管理',
      name: '名稱',
      sendRate: '發送頻率',
      content: '內容',
      config: '營銷配置',
      createTime: '創建時間',
      operation: '操作',
      edit: '修改',
      delete: '刪除',
      add: '新增',
      search: '查詢',
      sendRateOptions: {
        daily: '按天',
        monthly: '按月',
        unlimited: '不限制'
      }
    },
    marketPic: {
      title: '營銷圖片管理',
      image: '圖片',
      name: '名稱',
      url: '訪問地址',
      createTime: '創建時間',
      remark: '備註',
      operation: '操作',
      edit: '修改',
      delete: '刪除',
      add: '新增',
      search: '查詢'
    },
    marketGoods: {
      title: '營銷商品管理',
      name: '名稱',
      goodsCount: '商品數',
      createTime: '創建時間',
      remark: '備註',
      operation: '操作',
      edit: '修改',
      delete: '刪除',
      add: '新增',
      search: '查詢',
      viewGoods: '查看商品'
    }
  }
}